class RuleModel {
    constructor (data) {
        this.ruleId = data ? data.ruleId : 0
        this.name = data ? data.name : ""
        this.description = data ? data.description : ""
        this.status = data ? data.status : false
        this.chargeType = data ? data.chargeType : 0
        this.operation = data ? data.operation : 0
        this.accrualType = data ? data.accrualType : 1
        this.accrualAmount = data ? data.accrualAmount : 0
        this.bonusAccrualPeriod = data ? data.bonusAccrualPeriod : 0
        this.bonusCancellationPeriod = data ? data.bonusCancellationPeriod : 0
        this.assignmentText = data ? data.assignmentText : ""
        this.campaignId = data ? data.campaignId : 0
    }

    get accrualAmountHuman () {
        let text = ""
        switch (this.accrualType) {
            case 0:
                text = this.accrualAmount + " (%)"
                break
            case 1:
                text = this.accrualAmount + " (у.е.)"
                break
            case 2:
                text = "Цена товара"
                break
        }
        return text
    }

    get statusHuman () {
        return this.status ? "Активно" : "Неактивно"
    }

    get chargeTypeHuman () {
        let text = ""
        switch (this.chargeType) {
            case 0:
                text = "Транзакционный"
                break
            case 1:
                text = "Регулярный"
                break
        }
        return text
    }

    get operationHuman () {
        let text = ""
        switch (this.operation) {
            case 0:
                text = "Покупка"
                break
            case 1:
                text = "Платёж"
                break
            case 2:
                text = "Регистрация"
                break
            case 3:
                text = "Регулярный"
                break
        }
        return text
    }

    get accrualTypeHuman () {
        let text = ""
        switch (this.accrualType) {
            case 0:
                text = "Проценты (%)"
                break
            case 1:
                text = "Условные единицы (у.е.)"
                break
            case 2:
                text = "Цена товара"
                break
        }
        return text
    }

    static clearItems () {
        return {
            ruleId: 0,
            name: "",
            description: "",
            status: false,
            chargeType: 0,
            operation: 0,
            accrualType: 0,
            accrualAmount: 0,
            bonusAccrualPeriod: 0,
            bonusCancellationPeriod: 0,
            assignmentText: "",
            campaignId: 0,
        }
    }

    //   static setItems(data) {
    //     const model = new RuleModel();
    //     model.buildObj(data);
    //     return model;
    //   }
    //
    //   buildObj(data) {
    //     this.ruleId = data["RuleId"];
    //     this.name = data["Name"];
    //     this.description = data["Description"];
    //     this.status = data["Status"];
    //     this.chargeType = data["ChargeType"];
    //     this.operation = data["Operation"];
    //     this.accrualType = data["AccrualType"];
    //     this.accrualAmount = data["AccrualAmount"];
    //     this.bonusAccrualPeriod = data["BonusAccrualPeriod"];
    //     this.bonusCancellationPeriod = data["BonusCancellationPeriod"];
    //     this.assignmentText = data["AssignmentText"];
    //     this.campaignId = data["CampaignId"];
    //   }
}

export default RuleModel
